<!--
 * @Description: 设备统计
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-21 10:57:11
 * @LastEditTime: 2022-11-30 14:46:04
-->
<template>
<div class="DeviceStatic">
  <!-- 设备统计 -->
  <div class="chartItem">
    <div class="itemBox">
      <div class="chartBox" id="pBox" v-if="isShow">
        <ul ref="listRoll">
          <li v-for="({count, deviceTypeName, icon}, i) in list" :key="i" :title="count">
            <img :src="icon" alt="">
            <p>
              <span>{{count > 9999999999 ? '999999999+': count}}</span>
              <span>{{deviceTypeName}}</span>
            </p>
          </li>
        </ul>
      </div>
      <el-empty :image="imgSrc" :image-size="80" v-else></el-empty>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      imgSrc: require('../../assets/img/bigScreen/no-data.png'),
      isShow: true,
      list: [],
      timmer: null,
      rafId: null
      // leftData: [],
      // rightData: [],
    }
  },
  computed: {
    // idName() {
    //   return this.flag ? "echartsId9_big" : "echartsId9"
    // }
  },
  created() {
    // this.getDeviceStaticData();
  },
  mounted () {
    this.setRoll()
  },
  destroyed () {
    this.rafId && cancelAnimationFrame(this.rafId)
  },
  methods: {
    /**
     * @Description 设备统计-数据请求
     * @Author      YOYO - 2021-11-23
     */
    async getDeviceStaticData() {
      let { data, msg, code } = await this.request.post('/front/device/inwareStatistics')
      if (code !== 200) {
       if (code==500) {
          this.isShow = false
          return this.$message.error(msg)
        }
        return
      }
      if (data == null || data.length <= 0) {
        // 没数据时造假数据0
        data = [
          { deviceTypeName: "可燃气体探测器", count: 0, deviceClass: 1 },
          { deviceTypeName: "烟雾报警器", count: 0, deviceClass: 0 },
          { deviceTypeName: "液位", count: 0, deviceClass: 7 },
          { deviceTypeName: "水压", count: 0, deviceClass: 8 },
          { deviceTypeName: "门磁", count: 0, deviceClass: 9 },
          { deviceTypeName: "空开", count: 0, deviceClass: 11 },
          { deviceTypeName: "小工报", count: 0, deviceClass: 12 },
          { deviceTypeName: "一键报警", count: 0, deviceClass: 13 },
          // { deviceTypeName: "人体红外", count: 0, deviceClass: 16 },
          // { deviceTypeName: "跌倒检测雷达", count: 0, deviceClass: 17 },
          // { deviceTypeName: "摄像头", count: 0, deviceClass: 18 },
          // { deviceTypeName: "温湿度", count: 0, deviceClass: 19 }
        ]
      }

      if (data == null || data.length <= 0) return this.isShow = false

      let list = data.map(({count, deviceTypeName, deviceClass}) => {
        // 0烟雾、1可燃气体、2井盖、3电气火灾、6气体、7液位、8水压、9金安门磁、10声光、11空开、12英吉森小工报
        let icon = [0, 1, 2, 3, 6, 7, 8, 9, 10, 11, 12].indexOf(deviceClass) == -1 ? 'else' : deviceClass
        return {
          count,
          deviceTypeName,
          icon: require(`./../../assets/img/bigScreen/${icon}.png`)
        }
      })

      this.list = list
    },
    /**
     * @Description 设备统计-轮播
     * @Author      YOYO - 2021-11-23
     */
    async setRoll () {
      await this.getDeviceStaticData()

      if (!this.isShow) return

      let ulDom = this.$refs.listRoll
      let pDom = document.getElementById('pBox')

      if (ulDom.offsetHeight <= pDom.offsetHeight) return

      let temp = 0
      let flag = 0
      // 为实现无缝滚动，需要复制一份数据衔接一下
      let list = JSON.parse(JSON.stringify(this.list))
      this.list = this.list.concat(list)

      let lastTime = 0
      const step = 50 // 每50ms移动1px

      const animate = (timestamp) => {
        if (!this.isShow || !ulDom) {
          this.rafId && cancelAnimationFrame(this.rafId)
          return
        }
        if (timestamp - lastTime >= step) {
          lastTime = timestamp
          temp--

          if (temp <= -57) {
            let item1 = this.list[0]
            let item2 = this.list[1]
            this.list.splice(0, 2)
            this.$nextTick(() => {
              temp = 0
            })
            this.list.push(item1)
            this.list.push(item2)
          }
          this.$nextTick(() => {
            ulDom.style.transform = `translateY(${temp}px)`
          })
        }
        this.rafId = requestAnimationFrame(animate)
      }
      this.rafId = requestAnimationFrame(animate)
    }
  },

}
</script>

<style lang="scss" scoped>
.DeviceStatic {
  // font-size: 0;
  // text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  // position: relative;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;  
  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;

      .chartBox {
        width: 100%;
        height: calc(100% - 10px);
        overflow: hidden;
        padding: 5px;
        box-sizing: border-box;

        ::-webkit-scrollbar {
          display: none;
        }
        ul {
          // transition: 1s;
        }
        li {
          border:1px solid #39A4D5;
          display: inline-block;
          width: 46%;
          height: 50px;
          margin-left: 2.5%;
          margin-bottom: 5px;
          vertical-align: top;
          border-radius: 4px;
          >img {
            width: 50px;
            vertical-align: -2px;
            margin-top: 10px;
          }
          >p {
            display: inline-block;
            width: calc(100% - 50px);
            color: #FEFEFE;
            font-size: 12px;
            margin-left: -8px;
            text-align: center;
            span {
              display: block;
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              &:first-child {
                color: #02D9FD;
                font-family: PMZD;
                font-size: 18px;
              }
            }
          }
        }
        // .left{
        //   margin-right: 2%;
        // }
        // .left,
        // .right {
        //   float: left;
        //   // flex: 1;
        //   width: 49%;
        //   max-height: 100%;
        //   overflow: auto;

        //   // display: flex;
        //   // flex-direction: column;
        //   color: #fff;

        //   .item {
        //     height: 30%;
        //     min-height: 28%;
        //     // display: flex;
        //     overflow: hidden;
        //     margin-top: 5%;
        //     border: 2px solid #d89521;            
        //     // align-items: center;
        //   }

        //   .label {
        //     // flex: 1;
        //     float: left;
        //     height: 85%;
        //     // line-height: 100%;
        //     text-align: center;
        //     position: relative;

        //     i {
        //       // position: absolute;
        //       // top: 50%;
        //       // left: 50%;
        //       // transform: translate(-50%, -50%);

        //     }
        //   }

        //   .value {
        //     // flex: 2;
        //     float: left;
        //     text-align: center;
        //     // display: flex;
        //     height: 85%;
        //     // justify-content: center;
        //     // flex-direction: column;
        //     box-sizing: border-box;
        //     // overflow: hidden;
        //     width: 70%;
        //     .top {
        //       // float: left;
        //       // flex: 1;
        //       text-align: center;
        //       width: 100%;
        //       text-overflow:ellipsis;
        //       white-space:nowrap;
        //       overflow:hidden;
        //     }

        //     .bottom {
        //       // float: left;
        //       // flex: 1;
        //       text-align: center;
        //       width: 100%;
        //        text-overflow:ellipsis;

        //     }
        //   }

        //   .labelLeft {
        //     background-color: #FF8033;
        //   }

        //   .labelRight {
        //     background-color: #e7b932;
        //   }
        // }

        // .space {
        //   flex: .2;
        // }
      }
    }
  }
}
</style>
